// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

mat-dialog-content {
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 2px 24px !important;
  background-color: #f0f0f0;
  max-height: none !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.content {
  padding: 16px;
  border-radius: 4px;
  overflow-x: hidden !important;
}

.content table {
  width: 100%;
  max-width: 100%;
  table-layout: fixed;
}

.content th,
.content td {
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.table-responsive {
  max-width: 100%;
  overflow-x: hidden;
}

mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.test-section {
  display: block;
  font-size: 1.25rem;
  font-weight: 600;
  margin: 16px 0;
  text-align: left;
}

.button-gap { gap: 12px; }

.btn::after { content: '' !important; display: none !important; }

/* ── Project-details style tabs ──────────────────────────────── */
div.tabbed > ul.tabs {
  margin: 0 0 16px;
  padding: 0 0 0 8px;
  text-align: left;
  border-bottom: 1px solid #dbdcdd;
  list-style: none;
  display: flex;
  gap: 4px;
}

div.tabbed > ul.tabs li {
  padding: 10px 20px;
  cursor: default;
  font-size: 0.9rem;
  font-weight: 600;
  color: #0b2d71;
  border-bottom: 4px solid transparent;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
}

div.tabbed {
  margin: 0;
}

div.tabbed > ul.tabs li[aria-selected="true"] {
  color: #0b2d71;
  font-weight: 600;
  border-bottom: 4px solid #0b2d71;
}

/* ── Selection actions (Step 2) ──────────────────────────────── */
.selection-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.spacer-qaqc-table th,
.spacer-qaqc-table td {
  white-space: normal;
  overflow-wrap: anywhere;
  vertical-align: top;
}

.spacer-qaqc-table .spacer-qaqc-reading-col {
  min-width: 320px;
  max-width: 520px;
  white-space: normal;
  overflow-wrap: anywhere;
}

/* ── Spacer SSST readings grid (Step 2 & 3) ──────────────────── */
.spacer-ssst-table {
  table-layout: fixed;
  width: 100%;
}

.spacer-ssst-table th,
.spacer-ssst-table td {
  vertical-align: middle;
}

.spacer-ssst-table .ssst-readings-header {
  text-align: center;
}

`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/final-report-dialog/final-report-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,cAAc,SAAS,EAAE;;AAEzB,cAAc,sBAAsB,EAAE,wBAAwB,EAAE;;AAEhE,mEAAmE;AACnE;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mEAAmE;AACnE;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[":host {\n  display: block;\n  width: fit-content;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\nmat-dialog-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n  max-height: none !important;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n  overflow-x: hidden !important;\n}\n\n.content table {\n  width: 100%;\n  max-width: 100%;\n  table-layout: fixed;\n}\n\n.content th,\n.content td {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.table-responsive {\n  max-width: 100%;\n  overflow-x: hidden;\n}\n\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.test-section {\n  display: block;\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 16px 0;\n  text-align: left;\n}\n\n.button-gap { gap: 12px; }\n\n.btn::after { content: '' !important; display: none !important; }\n\n/* ── Project-details style tabs ──────────────────────────────── */\ndiv.tabbed > ul.tabs {\n  margin: 0 0 16px;\n  padding: 0 0 0 8px;\n  text-align: left;\n  border-bottom: 1px solid #dbdcdd;\n  list-style: none;\n  display: flex;\n  gap: 4px;\n}\n\ndiv.tabbed > ul.tabs li {\n  padding: 10px 20px;\n  cursor: default;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #0b2d71;\n  border-bottom: 4px solid transparent;\n  white-space: nowrap;\n  user-select: none;\n}\n\ndiv.tabbed {\n  margin: 0;\n}\n\ndiv.tabbed > ul.tabs li[aria-selected=\"true\"] {\n  color: #0b2d71;\n  font-weight: 600;\n  border-bottom: 4px solid #0b2d71;\n}\n\n/* ── Selection actions (Step 2) ──────────────────────────────── */\n.selection-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.spacer-qaqc-table th,\n.spacer-qaqc-table td {\n  white-space: normal;\n  overflow-wrap: anywhere;\n  vertical-align: top;\n}\n\n.spacer-qaqc-table .spacer-qaqc-reading-col {\n  min-width: 320px;\n  max-width: 520px;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n/* ── Spacer SSST readings grid (Step 2 & 3) ──────────────────── */\n.spacer-ssst-table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.spacer-ssst-table th,\n.spacer-ssst-table td {\n  vertical-align: middle;\n}\n\n.spacer-ssst-table .ssst-readings-header {\n  text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
